import React from 'react'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { TableFeature, useTiersInfo } from '@mc/plans-ui'
import { i18nInstance, INTRO_PRICING_I18N_NAMESPACE } from '../../i18n'
import { PricingCell } from './PricingCell'

const PricingFeatureComp = () => {
  const { t } = useTranslation(INTRO_PRICING_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label title={t('plans.features.pricing.title')} />
      <TableFeature.Individual>
        <PricingCell tier={individual} />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <PricingCell tier={duo} />
      </TableFeature.Duo>
      <TableFeature.Family>
        <PricingCell tier={family} />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}

export const PricingFeature = withI18nContext(i18nInstance)(PricingFeatureComp)
